import { PredefinedMessageLineModel } from "../schema/predefined-message-line.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class PredefinedMessageLineContainer extends MongoBaseContainer{
    predefined_message_line: PredefinedMessageLineModel
}